import { register, find, findAll } from '../../../../Javascript/Sysmex/Utils'

const ThumbnailGallery = el => {
  const prefix = el.dataset.prefix
  const images = findAll(`.${prefix}image`, el)

  const fitImageHeightToWidth = () => {
    images.forEach(image => {
      const imageWidth = image.offsetWidth
      const img = find('img', image)

      img.style.height = imageWidth + 'px'
    })
  }

  window.addEventListener('resize', fitImageHeightToWidth)

  fitImageHeightToWidth()
}

register('ThumbnailGallery', ThumbnailGallery)
